import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { BranchesSelectListModule } from '@portal-core/branches/components/branches-select-list/branches-select-list.module';
import { BranchAsyncModule } from '@portal-core/branches/pipes/branch-async/branch-async.module';
import { BuildAvatarModule } from '@portal-core/builds/components/build-avatar/build-avatar.module';
import { BuildsSelectListModule } from '@portal-core/builds/components/builds-select-list/builds-select-list.module';
import { BuildAsyncModule } from '@portal-core/builds/pipes/build-async/build-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectsSelectListModule } from '@portal-core/projects/components/projects-select-list/projects-select-list.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { TargetAvatarModule } from '@portal-core/targets/components/target-avatar/target-avatar.module';
import { TargetsSelectListModule } from '@portal-core/targets/components/targets-select-list/targets-select-list.module';
import { TargetAsyncModule } from '@portal-core/targets/pipes/target-async/target-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { BuildPickerComponent } from './build-picker.component';

@NgModule({
  declarations: [BuildPickerComponent],
  imports: [
    AutocompleteInputModule,
    BranchAvatarModule,
    BranchesSelectListModule,
    BuildAvatarModule,
    BuildsSelectListModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    McColorModule,
    MatListModule,
    MatProgressBarModule,
    MatSelectModule,
    ProjectAvatarModule,
    ProjectsSelectListModule,
    ReactiveFormsModule,
    TargetAvatarModule,
    TargetsSelectListModule,
    ProjectAsyncModule,
    BuildAsyncModule,
    BranchAsyncModule,
    TargetAsyncModule
  ],
  exports: [BuildPickerComponent]
})
export class BuildPickerModule { }
